import React, { useMemo, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import Tabs from '../../../atoms/Tabs/Tabs';
import { ActiveProblems } from './ActiveProblems';
import { ResolvedProblems } from './ResolvedProblems';
import useSafeLocationState from '../../../../hooks/useSafeLocationState';

const tabs = [
  {
    label: 'Active',
    id: 'active',
    value: 'active',
  },
  {
    label: 'Resolved',
    id: 'resolved',
    value: 'resolved',
  },
];

export const QBOIntegration = () => {
  useSafeLocationState('Accounting', 'Invoice Mapping Problems');

  const [tab, setTab] = useState(tabs[0]);

  const content = useMemo(() => {
    switch (tab.value) {
      case 'active': {
        return <ActiveProblems />;
      }
      case 'resolved': {
        return <ResolvedProblems />;
      }
      default:
        return null;
    }
  }, [tab.value]);

  return (
    <Stack padding={4} gap={4}>
      <Typography variant="h4" data-testid="page_title">
        Invoice Mapping Problems
      </Typography>

      <Tabs tabs={tabs} onTabChange={setTab} currentTab={tab} />
      {content}
    </Stack>
  );
};
